import { Component, OnInit, Input, Output } from '@angular/core';
import { RouteService } from 'app/services/route.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UntypedFormGroup, FormControl, Validators, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TimetableService } from 'app/services/timetable.service';
declare var $: any;

@Component({
  selector: 'manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageComponent implements OnInit {
  @Input('dataCntrl') dataCntrl: any;
  form;
  routeLeg: any;
  isLoading = false;
  message = null;
  isCreated = true;
  timetables: UntypedFormArray;
  interval: any = [];
  user = { LastName: '' };



  constructor(private timetblSrc: TimetableService, private authWebService: AuthWebService, private formBuilder: UntypedFormBuilder, private toastr: ToastrService) { }

  ngOnInit() {
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.initForm();
    ////console.log('dataCntrl = ', this.dataCntrl);
    this.onLoadTimetable();
  }
  initForm() {
    this.form = this.formBuilder.group({
      id: [0, []]
      , permit_id: [0, []]
      , route_id: [0, []]
      , timetable_direction: ['Forward', []]
      , timetable_interval: ['', []]
      , timetable_pair_num: [1, []]
      , is_all: [false, []]
      , is_for_day1: [false, []]
      , is_for_day2: [false, []]
      , is_for_day3: [false, []]
      , is_for_day4: [false, []]
      , is_for_day5: [false, []]
      , is_for_day6: [false, []]
      , is_for_day7: [false, []]
      //borderCrossings: this.formBuilder.array([]),
    });

  }
  onLoadTimetable = () => {
    if (this.dataCntrl.timeId > 0) {
      this.isCreated = false;
      this.onSwitchOnOrOff(true);
        this.message = 'Loading timetable, please wait...';
        this.timetblSrc.getById(this.dataCntrl.timeId).subscribe((rsrc:any) => {
          //console.log('Timetable = ', rsrc);

          this.form.patchValue({
            id: rsrc.timetable.id
            //, permit_id: rsrc.timetable.permit_id
            , route_id: rsrc.timetable.route_id
            , timetable_direction: rsrc.timetable.timetable_direction
            , timetable_interval: rsrc.timetable.timetable_interval
            , timetable_pair_num: rsrc.timetable.timetable_pair_num
            , is_all: rsrc.timetable.is_all
            , is_for_day1: rsrc.timetable.is_for_day1
            , is_for_day2: rsrc.timetable.is_for_day2
            , is_for_day3: rsrc.timetable.is_for_day3
            , is_for_day4: rsrc.timetable.is_for_day4
            , is_for_day5: rsrc.timetable.is_for_day5
            , is_for_day6: rsrc.timetable.is_for_day6
            , is_for_day7: rsrc.timetable.is_for_day7
          });

          this.onSwitchOnOrOff();
          //this.toastr.success('Create Timetable', 'Timetable created successfully');

        }, error => {
          //console.log('Form data = ', JSON.stringify(error));
          this.onSwitchOnOrOff();
          this.toastr.error('Failed to load timetable. If the problem persists, please contact system administrator.', 'Save Route');
        });
    }
  }


  //onLoadRouteById = (id) => {
  //  this.onSwitchOnOrOff(true);
  //  this.rutSrc.getRouteLegById(id).subscribe(
  //    resource => {
  //      this.routeLeg = resource;
  //      this.form.patchValue({
  //        id: this.routeLeg.id,
  //        route_type_ind: this.routeLeg.route_type_ind,
  //        display_ind: this.routeLeg.display_ind,
  //        code: this.routeLeg.code,
  //        route_detail: this.routeLeg.route_detail,
  //        route_summary: this.routeLeg.route_summary,
  //        description: this.routeLeg.description,
  //        is_active: this.routeLeg.is_active,
  //        sort_order: this.routeLeg.sort_order,
  //        group_code: this.routeLeg.group_code,
  //        date_created: this.routeLeg.date_created,
  //        departure_place_id: this.routeLeg.departure_place_id,
  //        destination_place_id: this.routeLeg.destination_place_id,
  //        departure_country_id: this.routeLeg.departure_country_id,
  //        destination_country_id: this.routeLeg.destination_country_id,
  //      });

  //      this.onSwitchOnOrOff();
  //    },
  //    error => {
  //      this.onSwitchOnOrOff();
  //      //console.log('Problems : ', error);
  //      this.toastr.error('Failed to load route. If the problem persists, please contact system administrator.', 'Save Route');

  //    }
  //  );
  //}

  onSwitchOnOrOff = (state = false) => {
    this.isLoading = state;
  }

  onSubmit = (form: any) => {
    ////console.log('Index 2 = ', this.dataCntrl.index);
    form.timetable_interval = this.setInterval();
    if (this.dataCntrl.isReturned) {

      ////console.log('Timetable ID: ', this.dataCntrl.timeId);
      this.onCreateReturnTimetable(form);
    } else {
    if (this.dataCntrl.timeId > 0) {
      this.onSwitchOnOrOff(true);
      this.message = 'Updating timetable, please wait...';
      form.user_modified = this.user.LastName;
      form = { timetable: form };
      this.timetblSrc.update(form).subscribe(rsrc => {
        ////console.log('Updated data = ', rsrc);
        this.onSwitchOnOrOff();
        $("#timeBtn").click();
        this.toastr.success('Timetable updated successfully', 'Update Timetable');
        this.onClose();
        this.dataCntrl.timeId = 0;
      }, error => {
        this.onSwitchOnOrOff();
        this.toastr.error('Failed to update timetable. If the problem persists, please contact system administrator.', 'Update Timetable');
        this.onClose();
        this.dataCntrl.timeId = 0;
      });
    } else {
      form.timetable_pair_num = this.dataCntrl.index;
      form.route_id = this.dataCntrl.application.route_id;
      // alert(JSON.stringify( this.dataCntrl.application.permits));
      // this.dataCntrl.application.permits.forEach(permit => {
      //   form.permit_id.push(permit.id);
      // });
     
      form.user_created = form.user_modified = this.user.LastName;
      this.onSwitchOnOrOff(true);
      this.message = 'Creating timetable, please wait...';
      form = { timetable: form };
      this.timetblSrc.add(form).subscribe(rsrc => {
        ////console.log('Saved data = ', rsrc);
        this.onSwitchOnOrOff();
        $("#timeBtn").click();
        this.toastr.success('Timetable created successfully', 'Create Timetable');
        setTimeout(() => {
          const timeoutId = setTimeout(() => {
            this.toastr.clear();
          }, 25000);
          
          clearTimeout(timeoutId);
        }, 3000);
        $("#timeBtn").click();
        this.onClose();
      }, error => {
        this.onSwitchOnOrOff();
        this.toastr.error('Failed to create timetable. If the problem persists, please contact system administrator.', 'Create Timetable');
        this.onClose();
      });
    }
  }

  }


  createTimetableLegs(leg: any = null): UntypedFormGroup {
    return this.formBuilder.group({
      legId: 0,
      placeFrom: 0,
      placeTo: 0,
      stepNum: 1,
      routeType: 0,
      stopType: 0,
      station_from: null,
      station_to: null,
      country_from: '',
      country_to: '',
      timetableLeg_id: 0,
      timetable_id: 0,
      depart_time: null,
      arrive_time: null,
      duration: null
    });
  }

  addRouteLegs(legs: any): void {
    this.timetables = this.form.get('timetables') as UntypedFormArray;
    let start = legs[0];
    let current: any;
    legs.forEach(leg => {
      if (leg.stepNum > 1) {
        this.timetables.push(this.formBuilder.group({
          legId: leg.legId,
          placeFrom: leg.placeFrom,
          placeTo: leg.placeTo,
          stepNum: leg.stepNum,
          routeType: leg.routeType,
          stopType: leg.stopType,
          station_from: leg.station_from,
          station_to: leg.station_to,
          country_from: leg.country_from,
          country_to: leg.country_to,
          timetableLeg_id: leg.timetableLeg_id,
          timetable_id: leg.timetable_id,
          depart_time: leg.depart_time,
          arrive_time: leg.arrive_time,
          duration: leg.duration
        }));
        start = leg;
      } else {
        this.form.patchValue({ first_place_leg_id: leg.legId });
      }
    })

  }


  isAll = (event: any) => {
    if (event.currentTarget.checked) {
      this.form.patchValue({
        is_for_day1: true
        , is_for_day2: true
        , is_for_day3: true
        , is_for_day4: true
        , is_for_day5: true
        , is_for_day6: true
        , is_for_day7: true
      });
      //this.interval.push(['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays', 'Sundays']);
    } else {
      this.form.patchValue({
        is_for_day1: false
        , is_for_day2: false
        , is_for_day3: false
        , is_for_day4: false
        , is_for_day5: false
        , is_for_day6: false
        , is_for_day7: false
      });
      this.interval = [];
    }
    //console.log('Interval = ', this.interval.toString());
  }

  setInterval = () => {
    this.interval = [];
    const isAll = this.form.get('is_all').value;
    if (isAll) {
      this.interval.push('Daily');

    } else {

      const intervals = [
        { key: this.form.get('is_for_day1').value, value: 'Mondays' },
        { key: this.form.get('is_for_day2').value, value: 'Tuesdays' },
        { key: this.form.get('is_for_day3').value, value: 'Wednesdays' },
        { key: this.form.get('is_for_day4').value, value: 'Thursdays' },
        { key: this.form.get('is_for_day5').value, value: 'Fridays' },
        { key: this.form.get('is_for_day6').value, value: 'Saturdays' },
        { key: this.form.get('is_for_day7').value, value: 'Sundays' }
      ];

      intervals.forEach(elm => {
        if (elm.key == true) {
          this.interval.push(elm.value);
        }
      });
    }
    //this.form.patchValue({ 'timetable_interval': this.interval.toString()});



    ////console.log('Interval = ', this.interval.toString());
    return this.interval.toString();


  }

  unSelectAll() {
    const intervals = [
      this.form.get('is_for_day1').value,
      this.form.get('is_for_day2').value,
      this.form.get('is_for_day3').value,
      this.form.get('is_for_day4').value,
      this.form.get('is_for_day5').value,
      this.form.get('is_for_day6').value,
      this.form.get('is_for_day7').value
    ];
    const isAll = (intervals.indexOf(false) == -1) ? true : false;
    this.form.patchValue({ is_all: (isAll) ? true : false });
  }


  onClose = () => {
    $("#Manager").modal('hide');
  }

  isValidForm = () => {
    const intervals = [
      this.form.get('is_for_day1').value,
      this.form.get('is_for_day2').value,
      this.form.get('is_for_day3').value,
      this.form.get('is_for_day4').value,
      this.form.get('is_for_day5').value,
      this.form.get('is_for_day6').value,
      this.form.get('is_for_day7').value
    ];
    return (intervals.indexOf(true) > -1) ? true : false;

  }

  onCreateReturnTimetable = (form: any) => {
    form.user_created = form.user_modified = this.user.LastName;
    form.timetable_direction = "Return"
    this.onSwitchOnOrOff(true);
      this.message = 'Creating return timetable, please wait...';
      form = { timetable: form };
      this.timetblSrc.createReturn(form).subscribe((rsrc:any) => {
        //console.log('created Return = ', rsrc);
        this.onSwitchOnOrOff();
        if (rsrc.isCreated) {
          $("#timeBtn").click();
          this.toastr.success('Return timetable created successfully', 'Create Return Timetable');
          const timeoutId = setTimeout(() => {
            this.toastr.clear();
          }, 4000);

          clearTimeout(timeoutId);

        } else {
          this.toastr.info("The timetable can't be used to create a return timetable.", 'Create Return Timetable');
        }
        this.onClose();
      }, error => {
        this.onSwitchOnOrOff();
        this.toastr.error('Failed to create return timetable. If the problem persists, please contact system administrator.', 'Create Return Timetable');
        this.onClose();
      });

  }


}
